document.addEventListener('DOMContentLoaded', () => {
    initCartProgressBar();
    observeCartChanges();
});

['cart:updated', 'cart:item-added', 'cart:item-removed', 'change'].forEach(event => {
    document.addEventListener(event, () => {
        setTimeout(initCartProgressBar, 500);
    });
});

function observeCartChanges() {
    const observer = new MutationObserver((mutations) => {
        mutations.forEach((mutation) => {
            if (mutation.addedNodes.length) {
                mutation.addedNodes.forEach(node => {
                    if (node.id === 'CartProgressBar' || (node.querySelector && node.querySelector('#CartProgressBar'))) {
                        initCartProgressBar();
                    }
                });
            }
        });
    });
    observer.observe(document.body, { childList: true, subtree: true });
}

function initCartProgressBar() {
    const bars = document.querySelectorAll('.cart-progress-bar-container');
    bars.forEach(progressBar => {
        const count = parseInt(progressBar.dataset.shirtCount || '0');
        const g1 = parseInt(progressBar.dataset.goal1 || '3');
        const g2 = parseInt(progressBar.dataset.goal2 || '5');
        const g3 = parseInt(progressBar.dataset.goal3 || '7');

        // Determine current stage (matches Liquid logic)
        let stage, stageStart, stageEnd;
        if (count < g1) {
            stage = 1; stageStart = 0;  stageEnd = g1;
        } else if (count < g2) {
            stage = 2; stageStart = g1; stageEnd = g2;
        } else {
            stage = 3; stageStart = g2; stageEnd = g3;
        }

        // Apply stage class (in case server stage is stale after AJAX update)
        progressBar.classList.remove('stage-1', 'stage-2', 'stage-3');
        progressBar.classList.add(`stage-${stage}`);
        progressBar.dataset.stage = String(stage);

        // Progress within current stage
        let percent = 0;
        if (count >= stageEnd) {
            percent = 100;
        } else if (count > stageStart) {
            percent = ((count - stageStart) / (stageEnd - stageStart)) * 100;
        }

        const fill = progressBar.querySelector('.cart-progress-bar__fill');
        if (fill) {
            requestAnimationFrame(() => { fill.style.width = `${percent}%`; });
        }

        // Mark milestones as reached
        const goalsByMilestone = { 'milestone-1': g1, 'milestone-2': g2, 'milestone-3': g3 };
        const markers = progressBar.querySelectorAll('.cart-progress-bar__milestone, .cart-progress-bar__step');
        markers.forEach(m => {
            let markerGoal = 0;
            for (const cls of Object.keys(goalsByMilestone)) {
                if (m.classList.contains(cls)) { markerGoal = goalsByMilestone[cls]; break; }
            }
            if (!markerGoal) {
                const stepMatch = Array.from(m.classList).find(c => c.startsWith('step-'));
                if (stepMatch) markerGoal = parseInt(stepMatch.replace('step-', '')) || 0;
            }
            if (count >= markerGoal && markerGoal > 0) {
                if (!m.classList.contains('is-reached')) {
                    m.classList.add('is-reached', 'pop-animation');
                    setTimeout(() => m.classList.remove('pop-animation'), 600);
                }
            } else if (markerGoal > 0) {
                m.classList.remove('is-reached', 'pop-animation');
            }
        });
    });
}
